export enum FileTypeEnum {
  CompanyAffiliates = 'CompanyAffiliates',
}
